import styled from '@emotion/styled';

export const ModalContent = styled.div`
  background-color: white;
  padding: 24px 40px;
`;

export const DropTableWrapper = styled.div`
  position: absolute;
  top: 60px;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(115, 115, 115, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;
